import { RobotsTxtContainer } from '@/modules/RobotsTxt';

export const RobotsTxt = (): JSX.Element => <RobotsTxtContainer />;

export default RobotsTxt;
